import {
	Button,
	Card,
	Checkbox,
	Col,
	Form,
	Row,
	Select,
	Typography
} from "antd";

import { Fragment, useEffect, useState } from "react";
import {
	Navigate,
	useLocation,
	useNavigate,
	useParams,
} from "react-router-dom";
import { toast } from "react-toastify";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";
import { addPermission, loadPermission } from "./roleApis";

function PermissionList(props) {
	const permissionNames = props.permissionNames;
	const { selectedPermission, setSelectedPermission } = props;

	// const onChange = (e) => {
	// 	const { value } = e.target;
	// };

	const permissionElements = permissionNames.map((item) => (
		<Fragment key={item.id}>
			<Checkbox
				value={item.id}
				onChange={() => {
					setSelectedPermission((prev) => {
						return {
							...prev,
							[item.id]: !prev[item.id],
						};
					});
				}}
				checked={selectedPermission[item.id]}>
				{item.name}
			</Checkbox>
		</Fragment>
	));

	const rows = [];
	for (let i = 0; i < permissionElements.length; i += 5) {
		rows.push(
			<div
				key={i}
				className='flex justify-between m-4 border-2 border-indigo-100 px-4 py-3'>
				{permissionElements.slice(i, i + 5)}
				<br />
			</div>
		);
	}
	return <div>{rows}</div>;
}

const AddPermission = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { Option } = Select;
	const [permissions, setPermissions] = useState([]);
	const [selectedPermission, setSelectedPermission] = useState({});
	//Loading Old data from URL
	const location = useLocation();
	const { data } = location.state;
	const roleName = data.name;
	const rolePermissions = data.rolePermission;
	// const role_id = rolePermissions[0].role_id; 
	const role_id = rolePermissions.length > 0 ? rolePermissions[0].role_id : null;
	console.log("rolePermissions", rolePermissions);
	const companyIdStr = localStorage.getItem("company_id");
	const companyId = parseInt(companyIdStr);


	const { Title } = Typography;
	const [form] = Form.useForm();
	const [loader, setLoader] = useState(false);

	useEffect(() => {
		loadPermission().then((d) => {
			setPermissions(d);
			const permissions = d.reduce((acc, item) => {
				acc[item.id] = rolePermissions.some((i) => i.permission_id === item.id);
				return acc;
			}, {});
			setSelectedPermission(permissions);
		});
	}, [id]);

	const permisionIds = Object.entries(selectedPermission).reduce(
		(acc, [key, value]) => {
			if (value) {
				acc.push(key);
			}
			return acc;
		},
		[]
	);

	const handleDropdownChange = (value) => {
		const newSelectedPermission = { ...selectedPermission };
		if (value === "all") {
			permissions.forEach((perm) => {
				newSelectedPermission[perm.id] = true;
			});
		} else {
			permissions.forEach((perm) => {
				if (perm.name.startsWith(value)) {
					newSelectedPermission[perm.id] = true;
				}
			});
		}
		setSelectedPermission(newSelectedPermission);
	};

	const clearAllPermissions = () => {
		const clearedPermissions = {};
		permissions.forEach((perm) => {
			clearedPermissions[perm.id] = false;
		});
		setSelectedPermission(clearedPermissions);
	};

	const onFinish = async (values) => {
		setLoader(true);
		try {
			const data = {
				role_id: parseInt(id),
				permission_id: permisionIds.map(Number),
			};

			// console.log(data, "data");

			const resp = await addPermission(data); //permision func

			if (resp.message === "success") {
				navigate(-1);
				setLoader(false);
			}
			if (resp.message === "error") {
				toast.error("Error at giving permission, Try again");
				setLoader(false);
				form.resetFields();
			}

			form.resetFields();
		} catch (error) {
			console.log(error.message);
			setLoader(false);
		}
	};

	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	const showPermitButton = companyId === 1 || role_id === null || role_id > 2;

	console.log("companyId> roleId>>", companyId, role_id)
	console.log("showPermitButton", showPermitButton)

	return (
		<>
			<PageTitle title={"Back"} />
			<UserPrivateComponent permission={"create-rolePermission"}>
				<Row className='mr-top' justify={"center"}>
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={24}
						xl={24}
						className='border rounded column-design'>

						{/* <Card bordered={false} className='criclebox h-full'>
							<Title level={3} className='m-3 text-center mb-5'>
								Add Permission: <span className='text-primary'>{roleName}</span>
							</Title>

							{permissions.length > 0 ? (
								<>


									<Select
										style={{ width: 300, marginBottom: 20 }}
										onChange={handleDropdownChange}
										placeholder="Select Permission Type"
										allowClear
									>
										<Option value="all">All Permissions</Option>
										<Option value="create">Create Permissions</Option>
										<Option value="readAll">Read All Permissions</Option>
										<Option value="readSingle">Read Single Permissions</Option>
										<Option value="update">Update Permissions</Option>
										<Option value="delete">Delete Permissions</Option>
									</Select>

									<Button
										className='m-3 w-80'
										onClick={clearAllPermissions}
										type='default'
										size='default'
										shape='round'
									>
										Clear All Permissions
									</Button>

									<PermissionList
										permissionNames={permissions}
										setSelectedPermission={setSelectedPermission}
										selectedPermission={selectedPermission}
									/>

									{showPermitButton && (
										<div className='text-center'>
											<Button
												className='m-3 w-80'
												onClick={onFinish}
												type='primary'
												size='large'
												shape='round'
												loading={loader}
											>
												Permit Now
											</Button>
										</div>
									)}
								</>
							) : (
								<Loader />
							)}
						</Card> */}

						<Card bordered={false} className='criclebox h-full'>
							<Title level={3} className='m-3 text-center mb-5'>
								Add Permission: <span className='text-primary'>{roleName}</span>
							</Title>

							{permissions.length > 0 ? (
								<>
									{/* Conditionally render the dropdown and Clear All Permissions button */}
									{showPermitButton && (
										<>
											<Select
												style={{ width: 300, marginBottom: 20 }}
												onChange={handleDropdownChange}
												placeholder="Select Permission Type"
												allowClear
											>
												<Option value="all">All Permissions</Option>
												<Option value="create">Create Permissions</Option>
												<Option value="readAll">Read All Permissions</Option>
												<Option value="readSingle">Read Single Permissions</Option>
												<Option value="update">Update Permissions</Option>
												<Option value="delete">Delete Permissions</Option>
											</Select>

											<Button
												className='m-3 w-80'
												onClick={clearAllPermissions}
												type='danger'
												size='default'
												shape='round'
											>
												Clear All Permissions
											</Button>
										</>
									)}

									<PermissionList
										permissionNames={permissions}
										setSelectedPermission={setSelectedPermission}
										selectedPermission={selectedPermission}
									/>

									{showPermitButton && (
										<div className='text-center'>
											<Button
												className='m-3 w-80'
												onClick={onFinish}
												type='primary'
												size='large'
												shape='round'
												loading={loader}
											>
												Permit Now
											</Button>
										</div>
									)}
								</>
							) : (
								<Loader />
							)}
						</Card>

					</Col>
				</Row>
			</UserPrivateComponent>
		</>
	);
};

export default AddPermission;
